import InfiniteScroller from './InfiniteScroller'

export default InfiniteScroller
